import { render, staticRenderFns } from "./ClientAutocomplete.vue?vue&type=template&id=1870dc1e&"
import script from "./ClientAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ClientAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports